import { render, staticRenderFns } from "./WindBarbsChart.vue?vue&type=template&id=63aea5c8&scoped=true&"
import script from "./WindBarbsChart.vue?vue&type=script&lang=js&"
export * from "./WindBarbsChart.vue?vue&type=script&lang=js&"
import style0 from "./WindBarbsChart.vue?vue&type=style&index=0&id=63aea5c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63aea5c8",
  null
  
)

export default component.exports